import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    sceneTimeline: {
        background: "black",
        color: "white",
    },
    sceneTimelinePointstop: {
        background: "black",
        color: "white",
        width: "45%",
        float: "right",
        margin: "0 auto",
    },
    reviewSceneNavContainer: {
        width: "100%",
        justifyContent: "space-between",
    },

    reviewSceneNavContainerPointstop: {
        width: "100%",

        justifyContent: "space-between",
    },
    sceneTimelineButton: {
        backgroundColor: "#3f51b5",
        color: "white",
        float: "right",
        marginTop: "1.75%",
        marginRight: "1.75%",

        "&:hover": {
            backgroundColor: "#6877ca",
        },
    },

    pointstopSessionButtons: {
        marginRight: "auto",
        order: 2,
    },

    slowMotionButton: {
        color: "white",
        float: "left",
        display: "inline-block",
        "&:hover": {
            backgroundColor: "#595959",
        },
        "&:disabled": {
            backgroundColor: "#737373",
        },
    },
}));

export { useStyles };
